export default __webpack_public_path__ + "static/media/info.3bfd9bb4.svg";